<tr class="table-body-row table-body-row--form" *ngIf="form">
  <td [attr.colspan]="cells.length" class="table-body-cell">
    <div class="table-body-cell-container">
      <!-- // form -->
      <form [formGroup]="formGroup" (submit)="DataService.update(row, row.id, formGroup, 'POST')" class="table-body-cell-container-form">
        <div class="table-body-cell-container-inputs">
          <ng-template ngFor let-cell [ngForOf]="row.cells">
            <!-- // name -->
            <sp-input
              [touched]="true"
              [type]="cell.input.type"
              [formControlName]="cell.input.name"
              name="myInput"
              [size]="'default inside'"
              [label]="cell.input.label"
              (change)="cell.input.onChange($event, row, cell)"
              *ngIf="cell.input && row.form"
            ></sp-input>
          </ng-template>
        </div>
        <div class="table-body-cell-container-form-actions">
          <!-- // form submit -->
          <sp-button [size]="'default'" [style]="'ghost ghost2'" [label]="'ارسل'" type="submit"></sp-button>
          <!-- // form revert and update form to be false. -->
          <sp-button [size]="'default'" [style]="'ghost'" (clickAction)="cancelTableForm(row)" [label]="'الغاء'"></sp-button>
        </div>
      </form>
    </div>
  </td>
</tr>
